<template>
  <div class="card shadow" >
    <div class="card-header border-0" >
      <div class="row align-items-center">
        <div class="col-md-3">
          <h3 class="mb-0">
            POS Version
          </h3>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <vuetable
        v-if="apiURL"
        ref="vuetable"
        :api-url="apiURL"
        :http-options="httpOptions"
        :fields="fields"
        :sort-order="sortOrder"
        :show-sort-icons="true"
        :per-page="10"
        :css="css.table"
        pagination-path=""
        data-path="data"
        no-data-template="Empty"
        @vuetable:load-error="onLoadError"
        @vuetable:pagination-data="onPaginationData"
      >
        <!-- version editing -->
        <template slot="version" slot-scope="props">
          <div v-if="editingRowId === props.rowData.terminal_id">
            <select
              v-model="selectedVersionMap[props.rowData.terminal_id].pos_update_id"
              class="form-control form-control-sm"
              style="width: 150px;"
            >
              <option disabled value="">Select version</option>
              <option
                v-for="v in availableVersionsMap[props.rowData.terminal_id]"
                :key="v.id"
                :value="v.id"
              >
                {{ v.version }} ({{ v.os }})
              </option>
            </select>
          </div>
          <div v-else>
            {{ props.rowData.version }}
          </div>
        </template>

        <!-- action fieldz -->
        <template slot="actions" slot-scope="props">
          <div v-if="editingRowId === props.rowData.terminal_id">
            <button
              class="btn btn-sm btn-success mr-1"
              @click="saveVersion(props.rowData)"
            >
              Save
            </button>
            <button
              class="btn btn-sm btn-secondary"
              @click="cancelEdit(props.rowData)"
            >
              Cancel
            </button>
          </div>
          <div v-else>
            <button
              class="btn btn-sm btn-primary"
              @click="enterEdit(props.rowData)"
            >
              Edit
            </button>
          </div>
        </template>
      </vuetable>
      <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import HTTPRequest from '../../controllers/httpRequest.js';
import secureStorage from '../../controllers/secureStorage';


export default {
  name: 'pos-tracking-version',
  props: {
    accountId: Number,
     siteId: Number,
    type: {
      type: String
    },
    title: String
  },
  components: {
    Vuetable,
    VuetablePagination,
  },
  computed: {
    ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters']),
  },
  data() {
    return {
        componentKey: 0,
      apiURL: "",
      filterStatus: "",
      fields: [
        {name: "terminal_id", title: "Terminal ID"},
        {name: "terminal_name", title: "Name"},
        {name: "site_name", title: "Site Name"},
        {name: "__slot:version", title: "Version"},
        {name: "operating_system", title: "Operating System"},
        {name: "status", title: "Status"},
         {name: "__slot:actions", title: "Actions", dataClass: "text-center"}
      ],
      editingRowId: null,
      availableVersionsMap: {}, 
      selectedVersionMap: {},
      versionOptions: [], 
      sortOrder: [{ field: "name", direction: "asc" }],
      httpOptions: {
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web"
        }
      },
      css: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      }
    }
  },
  mounted: function () {
    let params = this.parameters ? `${this.parameters}&account_id=${this.accountId}` : `?account_id=${this.accountId}`;
    if (this.siteId) params += `&site_id=${this.siteId}`;
    this.apiURL = `${this.endPoint}terminals/pos_versions${params}`;
  },
  watch: {
    accountId: async function() {
      let params = this.parameters ? `${this.parameters}&account_id=${this.accountId}` : `?account_id=${this.accountId}`;
      this.apiURL = `${this.endPoint}terminals/pos_versions${params}${this.siteId ? `&site_id=${this.siteId}` : ''}`;
      this.$refs.vuetable.resetData();
    },
    siteId: async function() {
      let params = this.parameters ? `${this.parameters}&account_id=${this.accountId}` : `?account_id=${this.accountId}`;
      if (this.siteId) params += `&site_id=${this.siteId}`;
      this.apiURL = `${this.endPoint}terminals/pos_versions${params}`;
      this.$refs.vuetable.resetData();
   },
    parameters: function () {
      let params = this.parameters ? `${this.parameters}&account_id=${this.accountId}` : `?account_id=${this.accountId}`;
      this.apiURL = `${this.endPoint}terminals/pos_versions${params}${this.siteId ? `&site_id=${this.siteId}` : ''}`;
      this.$refs.vuetable.selectedTo = []
    }
  },
  methods: {
    ...mapActions(['updateCurrentProfile', 'updateParameters', 'updateProfileId']),
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    log() {
      this.checkedItems = this.$refs.vuetable.selectedTo
    },
    async onLoadError(error) {
      console.log(error)
    },
    async enterEdit(row) {
      const id = row.terminal_id;
      const version = row.version
      this.editingRowId = row.terminal_id;
      this.$set(this.selectedVersionMap, row.terminal_id, {
        pos_update_id: "", //  default empty so "Select version" shows first
      });
      this.fetchAvailableVersions(id, version);
      const list = this.availableVersionsMap[id] || [];
      if (row.pos_update_id && !list.find(u => u.id === row.pos_update_id)) {
        list.unshift({ id: row.pos_update_id, version: row.version, os: row.operating_system });
        this.$set(this.availableVersionsMap, id, list);
      }
    },
    cancelEdit(row) {
      const id = row.terminal_id;
      this.editingRowId = null;
      this.$delete(this.selectedVersionMap, id);
    },
    async saveVersion(row) {
      const id = row.terminal_id;
      const sel = this.selectedVersionMap[id];
      if (!sel || !sel.pos_update_id) {
          alert('Please select a version.');
          return;
      }
      try {
        const payload = { pos_update_id: sel.pos_update_id };
        const url = `${this.endPoint}terminals/${id}/update_version`;
        const res = await HTTPRequest.putRequest(url, null, payload);
        console.log('save', payload)
        if (res && (res.success || res.data)) {
        this.editingRowId = null;
        this.$delete(this.selectedVersionMap, id);
        this.$refs.vuetable.refresh();
        } else {
          alert((res && res.error) || 'Unable to save version.');
        }
      } catch (err) {
        console.error(err);
        alert('Save failed. Check console for details.');
      }
    },
    async fetchAvailableVersions(terminal_id, version) {
      try {
        const res = await HTTPRequest.getRequest(`${this.endPoint}terminals/${terminal_id}/available_updates`, null, null);
        const data = (res && res.data) || [];
        this.$set(this.availableVersionsMap, terminal_id, data);
      } catch (err) {
        console.error('fetchAvailableVersions error', err);
        this.$set(this.availableVersionsMap, terminal_id, []); 
      }
    }
  }
}
</script>
